//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class StimulusControllers
{
	public static toursDetail: string = `tours--detail`;
	public static toursDetailAdditionalInformation: string = `tours--detail-additional-information`;
	public static tourMap: string = `tour-map`;
	public static destinationsIndex: string = `destinations--index`;
	public static destinationsDetail: string = `destinations--detail`;
	public static destinationsDetailBasicInformation: string = `destinations--detail-basic-information`;
	public static destinationsAddNewDestination: string = `destinations--add-new-destination`;
	public static onboarding: string = `onboarding`;
	public static destinationMap: string = `destination-map`;
	public static poisDetailBasicInformation: string = `pois--detail-basic-information`;
	public static poisDetailAiGeneratedContent: string = `pois--ai-generated-content`;
	public static toursDetailBasicInformation: string = `tours--detail-basic-information`;
	public static addDestinationPoiToTour: string = `add-destination-poi-to-tour`;
	public static indoorTourGeographicalInformation: string = `tours--detail-indoor-tour-geographical-information`;
	public static phonemesPagedList: string = `phonemes-paged-list`;
	public static destinationPagedList: string = `destination-paged-list`;
	public static hint: string = `hint`;
	public static hintPopup: string = `hint-popup`;
	public static destinationSearch: string = `destination-search`;
	public static usersPagedList: string = `users-paged-list`;
	public static companiesPagedList: string = `companies-paged-list`;
	public static translation: string = `translation`;
	public static bluetoothBeaconsEditor: string = `bluetooth-beacons-editor`;
	public static createNewPoiFromMap: string = `create-new-poi-from-map`;
	public static poisDetail: string = `pois--detail`;
	public static search: string = `search`;
	public static touristCard: string = `tourist-card`;
	public static poiPagedList: string = `poi-paged-list`;
	public static pagedListForm: string = `paged-list-form`;
}
